import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { fetchDiscount, pageNavigation } from '../../actions';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import  DiscountInfo  from './common/DiscountInfo'
import  Trigger  from './common/Trigger'
import  Discount  from './common/Discount'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import _ from 'lodash';

const propTypes = {
  discount: PropTypes.any,
  onSave: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func,
  params: PropTypes.object,
  products: PropTypes.any,
  discounts: PropTypes.any,
  items: PropTypes.any,
  isAuthenticated: PropTypes.bool.isRequired,
};

const styles = {
  floatingLabelStyle: {
    color: cyan900,
  },
  inputStyle: {
    marginRight: '2%',
    width: '250px',
  },
  datePickerStyle: {
    marginRight: '2%',
    width: '250px',
    float: 'left',
  },
  inline: {
    display: 'flex',
    width: '25%',
    float: 'left',
    marginTop: '30px',
  },
  inlineBlock: {
    display: 'inline-block',
    width: '30%',
  },
};
class EditDiscount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        discountType: null,
      },
      discount: {
        name: '',
        triggerMinOrderAmt: 0,
        triggerMinQty: 0,
        triggerByProduct: false,
        triggerAllProducts: false,
        triggerProducts: [],
        triggerByItem: false,
        triggerAllItems: false,
        triggerItems: [],
        discountType: null,
        discountValue: 0,
        discountPercent: 0,
        discountLimitQty: 0,
        discountProducts: [],
        discountItems: [],
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let discount = nextProps.discount;
    if (nextProps.discount.id) {
      discount = nextProps.discount;
    }
    // Requird because Swagger 2 does not support null values
    discount.id = (discount.id === null) ? 0 : discount.id;
    discount.discountLimitQty = (discount.discountLimitQty === null) ? 0 : discount.discountLimitQty;
    this.handleDiscountTypeChange(null, null, discount.discountType);
    this.setState({ discount });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const discount = this.state.discount;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = discount[paramName];
      required[paramName] = (param == null || param.length === 0 || param < 1) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleTriggerChange(e) {
    const required = this.state.required;
    const discount = this.state.discount;

    discount.triggerAllProducts = false;
    discount.triggerByItem = false;
    discount.triggerAllItems = false;
    discount.triggerByProduct = false;
    discount[e.target.name] = e.target.checked;

    if (discount.triggerAllProducts || discount.triggerByProduct) {
      required.triggerProducts = null;
      required.triggerMinQty = null;
    } else {
      delete required.triggerProducts;
    }
    if (discount.triggerByItem || discount.triggerAllItems) {
      required.triggerItems = null;
      required.triggerMinQty = null;
    } else {
      delete required.triggerItems;
    }
    if (!discount.triggerByItem && !discount.triggerAllItems && !discount.triggerAllProducts && !discount.triggerByProduct) {
      delete required.triggerMinQty;
    }

    this.setState({ required, discount, edited: true });
    this.setRequiredParams();
  }
  handleDiscountTypeChange(event, index, value) {
    const discount = this.state.discount;
    const required = this.state.required;
    delete required.discountValue;
    delete required.discountPercent;
    delete required.discountProducts;
    delete required.discountItems;
    discount.discountType = value;

    switch (discount.discountType) {
      case ('Flat Rate Shipping'):
      case ('Value Off Order'):
        required.discountValue = null;
        break;
      case ('Percent Off Order'):
      case ('Percent Off Shipping'):
        required.discountPercent = null;
        break;
      case ('Value Off Product'):
        required.discountValue = null;
        required.discountProducts = null;
        break;
      case ('Percent Off Product'):
        required.discountPercent = null;
        required.discountProducts = null;
        break;
      case ('Value Off Item'):
        required.discountValue = null;
        required.discountItems = null;
        break;
      case ('Percent Off Item'):
        required.discountPercent = null;
        required.discountItems = null;
        break;
      default:
        break;
    }
    this.setState({
      discount,
      required,
      edited: (index !== null),
    });
    this.setRequiredParams();
  }
  handleSelectChange(event, index, value, t) {
    const discount = this.state.discount;
    if (Array.isArray(discount[t])) {
      (discount[t].includes(value)) ? _.pull(discount[t], value) : discount[t].push(value); // eslint-disable-line
    } else {
      discount[t] = value;
    }
    this.setState({
      discount,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChange(e) {
    const discount = this.props.discount;
    if (e.target.type === 'checkbox') {
      _.set(discount, e.target.name, e.target.checked);
    } else {
      _.set(discount, e.target.name, e.target.value);
    }
    this.setState({
      discount,
      edited: true,
    });
    this.setRequiredParams();
  }
  navigateToView() {
    // if (this.state.edited === true) {
    //   const nextState = this.state;
    //   nextState.viewRedirect = true;
    //   this.setState(nextState);
    //   this.handleOpen();
    // } else {
      //browserHistory.push(`/discounts/view/${this.state.discount.id}`);
      // Use same component for Edit/View Disccount
      this.props.dispatch(fetchDiscount(this.props.discount.id));
      this.props.dispatch(pageNavigation('view'))
      if (!this.props.isAuthenticated) {
        browserHistory.push('/');
      }
    // }
  }
  navigateToEdit() {
    this.props.dispatch(fetchDiscount(this.props.discount.id));
    this.props.dispatch(pageNavigation('edit'))
    //browserHistory.push(`/discounts/${this.props.discount.id}`);
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      // browserHistory.push(`/discounts/view/${this.state.discount.id}`);
      this.props.dispatch(pageNavigation('view'))

    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Discount Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this discount?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState(nextState);
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.discount.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.discount);
        break;
      default:
        this.props.onSave(this.state.discount);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/discounts?page=1');
  }
  render() {
    const isTrue = true;
    const triggerProducts = this.state.discount.triggerProducts;
    const productsSelect = _.map(this.props.products, p => <MenuItem
      value={p.id}
      key={p.id}
      label={p.name}
      primaryText={p.name}
      checked={triggerProducts && triggerProducts.includes(p.id)}
    />);
    const triggerDiscountProducts = this.state.discount.discountProducts;
    const discountProductsSelect = _.map(this.props.products, dp => <MenuItem
      value={dp.id}
      key={dp.id}
      label={dp.name}
      primaryText={dp.name}
      checked={triggerDiscountProducts && triggerDiscountProducts.includes(dp.id)}
    />);
    const triggerItems = this.state.discount.triggerItems;
    const itemsSelect = _.map(this.props.items, i => <MenuItem
      value={i.id}
      key={i.id}
      label={i.name}
      primaryText={i.name}
      checked={triggerItems && triggerItems.includes(i.id)}
    />);
    const discountItems = this.state.discount.discountItems;
    const discountItemsSelect = _.map(this.props.items, i => <MenuItem
      value={i.id}
      key={i.id}
      label={i.name}
      primaryText={i.name}
      checked={discountItems && discountItems.includes(i.id)}
    />);
    return (
      <div style={{ width: '100%' }}>
        {!this.props.navigationType ? <h2>Edit Discount</h2> : <h2>View Discount</h2>}
        <div className="content">
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div>
          {!this.props.navigationType ?
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="View"
              primary
              onClick={this.navigateToView}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          : 
          <div className="content">
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Edit"
              primary
              onClick={this.navigateToEdit}
            />
          </div> 
          </div>
          }
          </div>
          <br />
          <DiscountInfo
          styles={styles}
          discount={this.props.discount}
          handleChange={this.handleChange}
          errorText={this.state.required.name}
          defaultChecked={this.state.discount.disabled}
          disableFields={this.props.navigationType}
          />
        </div> 
        <Trigger 
        styles={styles}
        handleTriggerChange={this.handleTriggerChange}
        discount={this.state.discount}
        isTrue={isTrue}
        handleSelectChange={this.handleSelectChange}
        triggerProducts={this.state.required.triggerProducts}
        triggerItems={this.state.required.triggerItems}
        triggerMinQty={this.state.required.triggerMinQty}
        productsSelect={productsSelect}
        discounttriggerMinQty = {this.props.discount.triggerMinQty }
        itemsSelect={itemsSelect}
        disableFields={this.props.navigationType}
        handleChange={this.handleChange}
        />
        <Discount 
        styles={styles}
        handleDiscountTypeChange={this.handleDiscountTypeChange}
        discountType={this.state.discount.discountType}
        discount={this.props.discount}
        handleChange={this.handleChange}
        errorText={this.state.required}
        discountProducts ={this.state.discount.discountProducts}
        discountItems={this.state.discount.discountItems}
        discountProductsSelect={discountProductsSelect}
        discountItemsSelect={discountItemsSelect}
        isTrue={isTrue}
        disableFields={this.props.navigationType}
        />
      </div>
    );
  }
}

EditDiscount.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditDiscount.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    discount: state.discounts.discount,
    products: state.products.results,
    items: state.items.results,
    isAuthenticated: state.auth.isAuthenticated,
    navigationType: state.admins.navigationType
  };
}

export default connect(mapStateToProps)(EditDiscount);



// WEBPACK FOOTER //
// ./src/components/discounts/EditDiscount.js